import { gql, useQuery } from "@apollo/client";
import { BestPerformingOffersAdminQueryQuery } from "../../../../../schemaTypes";

export const bestPerformingOffersAdminQuery = gql`
  query BestPerformingOffersAdminQuery {
    bestPerformingOffersAdmin {
      id
      title
      offerType
      redemptions
      createdBy {
        id
        admin {
          firstname
          lastname
          merchantProfile{
            id
            companyName
            businessName
          }
        }
      }
    }
  }
`;

export interface WithBestPerformingOffersAdmin {
  bestPerformingOffersAdmin: NonNullable<BestPerformingOffersAdminQueryQuery["bestPerformingOffersAdmin"]>;
}

interface Props {
  children: (data: WithBestPerformingOffersAdmin) => React.ReactElement | null;
}

export const BestPerformingOffersAdminController: React.FC<Props> = ({ children }) => {
  const { data } = useQuery<BestPerformingOffersAdminQueryQuery>(bestPerformingOffersAdminQuery);
  const bestPerformingOffersAdmin = data?.bestPerformingOffersAdmin ?? [];

  return children({ bestPerformingOffersAdmin });
};